import {
  formatAmount,
  lightTheme,
  NumberType,
} from '@vgrubs/components';

export const CustomYAxisTick = ({
  x,
  y,
  payload,
  currency,
}: {
  x: number;
  y: number;
  payload: { value: number };
  formatToDollars?: boolean;
  currency: NumberType;
}) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={-5}
        y={-13}
        dy={16}
        fontSize="14px"
        textAnchor="end"
        fill={lightTheme.lightGray}
      >
        {formatAmount(payload.value, currency, true)}
      </text>
    </g>
  );
};
